import { render, staticRenderFns } from "./GotoComponent.vue?vue&type=template&id=a4488e34"
import script from "./GotoComponent.vue?vue&type=script&lang=js"
export * from "./GotoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports